// Column metadata for the Numbers list page. Matches the ntconnect DID list
// entity: the phone number is `did` (11-digit), `primary` is 1/0, plus `id`
// and an optional `description`.
const numbercsvcolumndata = [
  {
    id: "id",
    title: "ID",
    default: true,
  },
  {
    id: "did",
    title: "Number",
    default: true,
  },
  {
    id: "description",
    title: "Description",
    default: true,
  },
  {
    id: "route",
    title: "Routed to",
    default: true,
  },
];

export default numbercsvcolumndata;
